import { render, staticRenderFns } from "./hmoAccredited.vue?vue&type=template&id=fef467fa&scoped=true"
import script from "./hmoAccredited.vue?vue&type=script&lang=js"
export * from "./hmoAccredited.vue?vue&type=script&lang=js"
import style0 from "./hmoAccredited.vue?vue&type=style&index=0&id=fef467fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fef467fa",
  null
  
)

export default component.exports